import { Blue500 } from '@zep-us/zus/tokens';
import { useTranslation } from 'next-i18next';
import { PaperFillIcon, UploadIcon } from '@/icons';
import { Button } from '@/ui_v3';
import { cn } from '@/utils';
export const UpdateFileForm = (props: {
  file: {
    name: string;
  };
  onUpdateFile?: React.MouseEventHandler<HTMLButtonElement>;
  withPreview?: boolean;
  onClickPreview?: () => void;
}) => {
  const {
    file,
    withPreview = false,
    onClickPreview
  } = props;
  const {
    t
  } = useTranslation(['build']);
  return <div className={cn('flex w-full items-center justify-between gap-xs rounded-sm border border-alternative bg-white px-lg py-xl min-h-[121px]', withPreview && 'max-mobile-lg:items-stretch max-mobile-lg:flex-col max-mobile-lg:gap-lg')} data-sentry-component="UpdateFileForm" data-sentry-source-file="UpdateFileForm.tsx">
      <div className={'flex items-center gap-xs'}>
        <PaperFillIcon className={'shrink-0'} size={'xl'} fill={Blue500} data-sentry-element="PaperFillIcon" data-sentry-source-file="UpdateFileForm.tsx" />
        <span title={file.name} className={'line-clamp-1 text-body-md-semibold text-default'}>
          {file.name}
        </span>
      </div>

      <div className={'flex shrink-0 gap-xs'}>
        {withPreview && <Button className={cn(withPreview && 'max-mobile-lg:w-full')} variant={'outlined'} intent={'neutral'} rounded={'full'} size={'md'} onClick={onClickPreview}>
            {t('learningMaterial.preview')}
          </Button>}
        <Button className={cn(withPreview && 'max-mobile-lg:w-full')} variant={'outlined'} intent={'alternative'} rounded={'full'} size={'md'} leftSlot={<UploadIcon size={'md'} />} onClick={props.onUpdateFile} data-sentry-element="Button" data-sentry-source-file="UpdateFileForm.tsx">
          {t('build.ai.changeFile')}
        </Button>
      </div>
    </div>;
};